var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component, isValidElement } from 'react';
/**
 * ErrorBoundary component based on DataDog's example
 * To be extended in DEP-4655 to include logging and error reporting
 * https://github.com/DataDog/rum-react-integration-examples/blob/master/src/ErrorBoundary/ErrorBoundary.ts
 */
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false, prevScope: props.scope };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error: error };
    };
    ErrorBoundary.getDerivedStateFromProps = function (props, state) {
        if (state.prevScope !== props.scope) {
            return {
                hasError: false,
                error: undefined,
                prevScope: props.scope,
            };
        }
        return state;
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        var onCaughtError = this.props.onCaughtError;
        if (typeof onCaughtError === 'function') {
            onCaughtError(error, errorInfo);
        }
        var RumGlobal = window.DD_RUM;
        if (RumGlobal) {
            var scope = this.props.scope;
            RumGlobal.addError(error, {
                scope: scope,
            }, 'source');
        }
    };
    ErrorBoundary.prototype.render = function () {
        var _a = this.state, hasError = _a.hasError, error = _a.error;
        var _b = this.props, fallback = _b.fallback, children = _b.children;
        if (!hasError || !error) {
            return children;
        }
        if (isValidElement(fallback) || typeof fallback === 'string') {
            return fallback;
        }
        if (typeof fallback === 'function') {
            return fallback(error);
        }
        return null;
    };
    // static default props is preferred for Class components
    // https://react.dev/reference/react/Component#static-defaultprops
    ErrorBoundary.defaultProps = {
        scope: 'error-boundary',
    };
    return ErrorBoundary;
}(Component));
export { ErrorBoundary };
export function withErrorBoundary(WrappedComponent, fallback, onCaughtError) {
    // as we spread the props due to the unknown nature of them we need to define the type as T & {}
    // This is to handle the case where the wrapped component doesn't have any props.
    // if props are input as undefined or null the props will be provided as an empty object.
    // This is what makes the props always spreadable
    // see https://react.dev/reference/react/createElement#createelement
    var ComponentWithErrorBoundary = function (props) {
        return (React.createElement(ErrorBoundary, { fallback: fallback, onCaughtError: onCaughtError },
            React.createElement(WrappedComponent, __assign({}, props))));
    };
    return ComponentWithErrorBoundary;
}
